// Account Settings → Privacy & Safety (1.27.70). A summary of settings that live on
// other screens; each row opens the screen where it is changed.
//
// The concept's "Blocked accounts" is Muted accounts: TruXSocial has no blocking,
// by design (owner ruling), and a Block affordance anywhere is a bug. Its
// "Sensitive content" and "Muted words" rows are left off (owner ruling
// 2026-09-30): neither filter exists, and keyword filters are README-deferred.
import { useMutedAccountsList } from '@/hooks';
import type { User } from '@/core/models';
import { CardHead, DashCard, DashLinkRow } from '../../dashboard/DashCard';
import { RowList } from '../../dashboard/dashStyles';

const AUDIENCE: Record<'everyone' | 'following' | 'nobody', string> = {
  everyone: 'Everyone',
  following: 'People I follow',
  nobody: 'Nobody',
};

export function PrivacySafetyCard({ user }: { user: User }) {
  const { accounts, loading, error } = useMutedAccountsList();
  return (
    <DashCard labelledBy="acct-privacy-title" testId="privacy-safety-card">
      <CardHead icon="lock" title="Privacy & Safety" titleId="acct-privacy-title" />
      <RowList>
        <DashLinkRow
          to="/settings/privacy"
          icon="eye"
          label="Profile visibility"
          value={user.privateAccount ? 'Private' : 'Public'}
        />
        <DashLinkRow
          to="/settings/privacy"
          icon="comment"
          label="Message permissions"
          value={AUDIENCE[user.dmPolicy ?? 'everyone']}
        />
        <DashLinkRow
          to="/settings/privacy"
          icon="at-sign"
          label="Who can mention you"
          value={AUDIENCE[user.mentionPolicy ?? 'everyone']}
        />
        <DashLinkRow
          to="/settings/content"
          icon="volume-x"
          label="Muted accounts"
          value={loading || error ? '' : accounts.length}
          testId="muted-accounts-row"
        />
        <DashLinkRow
          to="/settings/privacy"
          icon="user-plus"
          label="Suggest my account"
          value={user.suggestible === false ? 'Off' : 'On'}
        />
      </RowList>
    </DashCard>
  );
}
